import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Modal, Button } from "semantic-ui-react";

import { MoneyInput } from "components/shared";

export default function AddModal({
  contractId,
  data,
  onClose,
  open,
  onConfirm,
}) {
  const [tierData, setTierData] = useState(null);
  const [error, setError] = useState(null);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [amountError, setAmountError] = useState(null);

  useEffect(() => {
    if (!data) return;
    fetchTierData();
  }, [open]);

  if (!data) return null;

  function fetchTierData() {
    if (!open) return;

    axios
      .get(`/pricing-tiers/${data.pricing_tier_id}/`)
      .then(({ data }) => {
        setTierData(data);
      })
      .catch((err) => {
        setError(`We couldn't locate the requirements.`);
      });
  }

  function onAmountSubmit() {
    const amountInPennies = parseFloat(amount) * 100;

    const req = {
      dealer_requested_amount: amountInPennies,
      pricebook_hvac_system_id: data.id,
      contract_id: contractId,
    };

    setLoading(true);
    setAmountError(null);

    axios
      .post(`/contract-system-price-check/`, req)
      .then(({ data }) => {
        setLoading(false);
        if (data) {
          onConfirm(amountInPennies);
        } else {
          setAmountError("Income does not support system");
        }
      })
      .catch((err) => {
        setLoading(false);
        setAmountError(err.response.data.ui_message);
      });
  }

  return (
    <Modal open size="tiny" onClose={onClose}>
      <Modal.Header content="Requirements" />
      <Modal.Content>
        {tierData && data && (
          <div>
            <p>
              These are the requirements for installing a{" "}
              <b>
                {tierData.name} {data.name}
              </b>
              :
            </p>
            <ul>
              <li>Furnace: {tierData.furnace_rule}</li>
              <li>Seer: {tierData.seer_rule}</li>
              <li>Stage: {tierData.stage_rule}</li>
            </ul>
          </div>
        )}
        <Form>
          <Form.Field>
            <label>Total Quote including all materials</label>
            <MoneyInput
              value={amount}
              onChange={(e) => {
                setAmount(e.target.value);
                setAmountError(null);
              }}
            />
          </Form.Field>
        </Form>
        {amountError && (
          <p style={{ color: "red", marginTop: "1em", fontWeight: "bold" }}>
            {amountError}
          </p>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button content="Cancel" basic onClick={onClose} />
        <Button
          content="Confirm"
          loading={loading}
          onClick={onAmountSubmit}
          positive
          disabled={!amount}
        />
      </Modal.Actions>
    </Modal>
  );
}

AddModal.defaultProps = {
  data: null,
  open: false,
};

const furnaceVariety = [];
